import { create } from 'zustand';

import { groupApi } from '@/api';

interface GroupStore {
  botDetail: any;
  trackList: any[];
  botId: string;
  setBotDetail: () => void;
  setTrackList: (botId: string) => void;
  setBotId: (id: string) => void;
}

// @ts-ignore
export const useGroupStore = create<GroupStore>()(set => ({
  botDetail: {},
  trackList: [],
  // 群列表选中的智能体
  botId: '',

  setBotDetail: async () => {
    const res = await groupApi.feimaChatCommunityGetCollectBot();
    set({ botDetail: res });
  },

  setTrackList: async (botId: string) => {
    const res = await groupApi.feimaChatCommunityGetFollowBotList({
      botId,
    });
    set({ trackList: res.list });
  },

  setBotId: (id: string) => {
    set({ botId: id });
  },
}));
